export default __webpack_public_path__ + "static/media/PawPatrol_01.472cbcc7.png";